const SERVICES_NAV_LINKS = [
  {
    id: 1,
    label: "AI Engineering & Agentic Workflows",
    path: "/services/solutions/data-ai-analytics",
    description: "Generative AI, Agentic workflows, LLM orchestration & enterprise AI pipelines"
  },
  {
    id: 2,
    label: "Azure / .NET Modernization",
    path: "/services/solutions/cloud-devops-security",
    description: "Cloud-native architectures, legacy .NET modernization & Azure infrastructure"
  },
  {
    id: 3,
    label: "Enterprise QA Automation",
    path: "/services/solutions/product-engineering",
    description: "End-to-end test automation, continuous testing & QA frameworks"
  },
  {
    id: 4,
    label: "Dedicated Engineering Pods",
    path: "/services/solutions/talent-intelligence",
    description: "Autonomous high-performance offshore engineering pods & GCC capability centers"
  }
];

const ABOUT_NAV_LINKS = [
  {
    id: 1,
    label: "Leadership & Engineering DNA",
    path: "/#about",
    section: "about",
    description: "Meet our executive leadership and learn about our engineering culture"
  },
  {
    id: 2,
    label: "Partner & White-Label Delivery",
    path: "/services/solutions/business-transformation-advisory",
    description: "Strategic partnerships, enterprise consulting & white-label execution"
  }
];

const PRODUCTS_NAV_LINKS = [
  {
    id: 1,
    label: "ProHireY",
    badge: "Recruitment AI",
    path: "https://prohirey.com",
    isExternal: true
  },
  {
    id: 2,
    label: "ToxBox AI",
    badge: "Voice Agent",
    path: "https://toxboxai.com",
    isExternal: true
  },
  {
    id: 3,
    label: "Sailsense AI",
    badge: "AI Avatars",
    path: "/products",
    isExternal: false
  }
];

const SOLUTIONS_NAV_LINKS = SERVICES_NAV_LINKS;
const INDUSTRIES_NAV_LINKS = [];

export { SERVICES_NAV_LINKS, ABOUT_NAV_LINKS, PRODUCTS_NAV_LINKS, SOLUTIONS_NAV_LINKS, INDUSTRIES_NAV_LINKS };